import { render, staticRenderFns } from "./Doseage.vue?vue&type=template&id=373cfa3e&scoped=true&"
import script from "./Doseage.vue?vue&type=script&lang=js&"
export * from "./Doseage.vue?vue&type=script&lang=js&"
import style0 from "./Doseage.vue?vue&type=style&index=0&id=373cfa3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373cfa3e",
  null
  
)

export default component.exports